<template>
  <div class="edit-email">
    <editor
      v-show="!showCode"
      :content="editorContent"
      @change="handleChangeEditor"
      @showHtml="showHtml"
    />
    <div
      v-show="showCode"
      class="code-box"
    >
      <div class="tool-box clearfix">
        <a
          class="back-btn"
          @click="hideCode"
        >
          富文本编辑
          <i class="iconfont iconchange" />
        </a>
      </div>
      <codemirror
        ref="codemirrorRef"
        :value="codeContent"
        :options="options"
        @focus="handleFocusCode"
        @blur="handleBlurCode"
        @input="handleInputCodeContent"
      />
    </div>
  </div>
</template>

<script>
import { setStorage } from '@/lib/storage'
import Editor from './Editor'
import { codemirror } from 'vue-codemirror'

// language
import 'codemirror/mode/xml/xml.js'

// theme css
import 'codemirror/theme/ambiance.css'

// require active-line.js
import 'codemirror/addon/selection/active-line.js'

// autoCloseTags
import 'codemirror/addon/edit/closetag.js'
import { mapMutations } from 'vuex'

var beautifyHtml = require('js-beautify').html

export default {
  name: 'EditEmail',
  components: {
    Editor,
    codemirror
  },
  props: {
    emailid: {
      type: [Number, String],
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      editorContent: '',
      codeContent: '',
      showCode: false
    }
  },

  computed: {
    options: function () {
      return {
        styleActiveLine: true,
        lineNumbers: true,
        autoCloseTags: true,
        line: true,
        lineWrapping: true,
        mode: 'text/html',
        autofocus: true,
        autoRefresh: true
      }
    }
  },

  watch: {
    content (val) {
      if (val === undefined) return
      this.editorContent = val
      this.codeContent = val
    }
  },

  methods: {
    ...mapMutations('edm/editEmail', ['SET_EMAIL_INFO', 'SET_ERROR']),

    handleInputCodeContent (value) {
      this.codeContent = value
    },
    handleFocusCode (value) {
      this.formatCode()
    },
    handleBlurCode () {
      this.formatCode()
    },
    handleChangeEditor (value) {
      if (value === undefined) return

      this.editorContent = value
    },
    showHtml (show) {
      this.showCode = show
      this.codeContent = this.editorContent
      let timer = null
      clearTimeout(timer)
      timer = setTimeout(() => {
        this.$refs.codemirrorRef.codemirror.refresh()
        this.formatCode()
      }, 50)
    },
    hideCode () {
      this.$confirm({
        title: '注意',
        content: '切换成富文本编辑后保留当前的内容，可能会出现部分标签丢失现象，确定要切换吗？',
        closable: true,
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        class: 'confirm-warn-modal',
        onOk: async () => {
          this.editorContent = this.codeContent
          this.showCode = false
        }
      })
    },
    formatCode () {
      let content = this.codeContent
      this.codeContent = beautifyHtml(content, { indent_size: 2 })
      this.$refs.codemirrorRef.codemirror.setValue(this.codeContent)
    },
    setStorageEmailContent () {
      let content = this.showCode ? this.codeContent : this.editorContent
      setStorage('email.content', content)
    },
    handleSubmit () {
      let _this = this
      return new Promise(function (resolve, reject) {
        let content = _this.showCode ? _this.codeContent : _this.editorContent

        if (content) {
          _this.SET_EMAIL_INFO({ content })
          _this.SET_ERROR({ tab1Error: false })
          resolve(false)
        } else {
          _this.$message.destroy()
          _this.$message.error('邮件内容不能为空')
          _this.SET_ERROR({ tab1Error: true })
          resolve(true)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.edit-email ::v-deep {
  height: calc(100vh - 180px);
  .code-box, .vue-codemirror, .CodeMirror {
    height: calc(100% - 18px);
  }
}
.tool-box {
  padding: 12px 24px;
  width: 1280px;
  background:#fff;
  border-bottom: 1px solid #EBEBEB;
  .back-btn {
    float: right;
    width: 106px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    font-weight: 400;
    color:#000;
    background:#fff;
    border-radius: 2px;
    border: 1px solid #EBEBEB;
    .iconfont {
      color: #d8d8d8;
    }
  }
}
</style>
